
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _4045lxlcK4fA34GWnxLuH1KuvKyRblIXBwJTZ7pugZJ9cAMeta } from "/var/www/go-vue/client/pages/404.vue?macro=true";
import { default as indexcyMjBOVNtPNohB1b5BhUuw296rSqrXXNBhp3ShCGZ2YMeta } from "/var/www/go-vue/client/pages/index.vue?macro=true";
import { default as _91id_93tVCvEq6DsP1AlLXSkKANen_45N2D1GiOuFhltLNMDhPAIMeta } from "/var/www/go-vue/client/pages/project/[id].vue?macro=true";
import { default as projectRSfpb4aHcnWhe7Nl_450l1Vik8W4hI_45EepgjcLarBGwcMMeta } from "/var/www/go-vue/client/pages/project.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    component: () => import("/var/www/go-vue/client/pages/404.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/go-vue/client/pages/index.vue")
  },
  {
    name: "project",
    path: "/project",
    component: () => import("/var/www/go-vue/client/pages/project.vue"),
    children: [
  {
    name: "project-id",
    path: ":id()",
    component: () => import("/var/www/go-vue/client/pages/project/[id].vue")
  }
]
  }
]